import {imageMap} from "../../../../images/imageMap.ts";
import {Link} from "react-router-dom";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";
import Routing from "../../../../Routing.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";

export default function WifiFindNavnKodeArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Her kan du finde hjælp, hvis du har problemer med at finde dit navn og kodeord til dit wifi.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <h2>
                        Vælg dit produkt for at finde hjælp
                    </h2>
                    <div className={'button-container'}>
                        <a href={'#fiber'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har fibernet / internet via telefonstikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#coax'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har internet via kabel-tv-stikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#mbb'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har 5G-internet
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#not-sure'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg ved ikke, hvilket produkt jeg har
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className="article article--connect">
                    <div className="paragraph">
                        <h3>Jeg har fibernet / internet via telefonstikket</h3>
                        <ul className="list list--bullet list--image">
                            <li>
                                <p>
                                    Dit wifi-navn og -kode står bag på routeren.
                                </p>
                                <ul className="list list--bullet list--compact">
                                    <li><p>
                                        Dit wifi-navn står ud for <strong>SSID</strong> og din kode står ud for <strong>Wireless key</strong>.
                                    </p></li>
                                </ul>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel_ex3.wifi_login}
                                alt="Grafik som viser wifi login på bagsiden af en Zyxel router."
                            />
                            <li>
                                <p>
                                    Hvis du selv har ændret navnet eller koden, skal du logge på din router for at se det.
                                    Se vejledningen nedenfor.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            Inde i routeren kan du også ændre navn og kode på wifi.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Læs mere om at <Link to={'/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi'}>skifte navn og kode på dit wifi her</Link>.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelGuiHomeWifi}
                                alt="Grafik som illustrerer Wifi indstillinger på en Zyxel router."
                            />
                        </ul>
                    </div>
                </div>
                <div className="article article--connect">
                    <div className={'paragraph'}>
                        <h4>Hvordan logger jeg ind i routeren?</h4>
                        <ul className="list list--number list--image">
                            <li><p>
                                Åbn din browser.
                            </p></li>
                            <li><p>
                                Søg på &ldquo;192.168.1.1&rdquo;.
                            </p></li>
                            <li><p>
                                Log ind med <strong>User Name</strong> og <strong>Login Password</strong>, som står bag på din router.
                            </p></li>
                            <img
                                src={imageMap.help.network.gui.zyxel_ex3.gui_login}
                                alt="Grafik som viser login til GUI på bagsiden af en Zyxel router."
                            />
                        </ul>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h4>Har du glemt din wifi-kode?</h4>
                        <ul className={'list list--bullet'}>
                            <li>
                                <p>
                                    Hvis du har glemt din wifi-kode eller ikke kan logge ind i routeren, skal du nulstille din router:
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        <p>
                                            Hold reset-knappen nede bag på routeren i 20 sekunder, mens routeren er tændt.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    <strong>Obs.:</strong>{' '}
                                    Når du nulstiller din router, bliver alle indstillinger på routeren nulstillet.
                                    Dit wifi-navn og -kode bliver nulstillet til det, som står bag på routeren.
                                </p>
                            </li>
                        </ul>
                        <img
                            className="paragraph-image paragraph"
                            src={imageMap.help.equipment.zyxelReset}
                            alt="Grafik som viser reset-knappen bagsiden af en Zyxel router."
                        />
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'coax'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>Jeg har internet via kabel-tv-stikket</h3>
                        <ul className={'list list--bullet'}>
                            <li>
                                <p>
                                    Du kan se dit wifi-navn og kode på <a href="https://mitwifi.dk/" target="_blank">mitwifi.dk</a>.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Du skal bruge et kontonummer og en aktiveringskode for at logge på{' '}
                                    <a
                                        href="https://mitwifi.dk/"
                                        target="_blank"
                                    >mitwifi.dk</a>.
                                    Det finder du i Mit Hiper:
                                </p>
                                <ul className="list list--number">
                                    <li>
                                        <p>
                                            Log på <Link to={Routing.Selfcare.Account}>Mit Hiper</Link>.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Vælg fanen <strong>Profil</strong>.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Kontonummer og aktiveringskode står ved <strong>Login til mitwifi.dk</strong>.
                                        </p>
                                    </li>
                                    <img
                                        className="box-shadow"
                                        src={imageMap.help.network.selfcareProfileMitwifi} alt="Dit login til mitwifi.dk i Mit Hiper"
                                    />
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Log på{' '}
                                    <a
                                        href="https://mitwifi.dk/"
                                        target="_blank"
                                    >mitwifi.dk</a>{' '}
                                    med kontonummeret og aktiveringskoden.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Du kan se dit wifi-navn og kode under <strong>Dit Trådløse Netværk</strong>.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            Tryk på øje-ikonet for at se din wifi-kode.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <img src={imageMap.help.network.mitwifi.mitwifiOversight} alt="Oversigt over wifi-login på mitwifi.dk"/>
                        <p>
                            Se hvordan du <Link to="/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi">skifter navn og kode på dit wifi her</Link>!
                        </p>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'mbb'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>Jeg har 5G-internet</h3>
                        <ul className="list list--bullet list--image">
                            <li>
                                <p>
                                    Dit wifi-navn og -kode står i bunden af din router.
                                </p>
                                <ul className="list list--bullet">
                                    <li><p>
                                        Dit wifi-navn står ud for <strong>WiFi SSID</strong>.
                                    </p></li>
                                    <li><p>
                                        Din wifi-kode står ud for <strong>WiFi Key</strong>.
                                    </p></li>
                                </ul>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel_nr5307.zyxelNr5307WifiLogin}
                                alt="Grafik som viser wifi login på undersiden af en Zyxel 5G-router."
                            />
                        </ul>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>{WhatConnectionType.question}</h3>
                        {WhatConnectionType.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4- og 5 GHz"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    }
                ]}
            />
        </>
    )
}